import { updateStats } from './stats';
import { saveUserData } from '../auth/kindeClient';
import { getUser } from './views';

function saveRewards(rewards) {
    const user = getUser();
    user.mana += rewards.mana;
    user.coins += rewards.coins;
    user.gems += rewards.gems;
    updateStats(user.mana, user.coins, user.gems);
    const today = new Date();
    user.dailyChest = today.toISOString();
    saveUserData(user);
}

function showRewardsModal(rewards) {
    const rewardsModal = document.querySelector('.rewards-modal');
    rewardsModal.innerHTML = `
        <h2>Your Rewards</h2>
        <p id="rewardMana">⭐️ Mana: 0</p>
        <p id="rewardGems">🔮 Gems: 0</p>
        <p id="rewardCoins">💰 Coins: 0</p>
        <button onclick="document.querySelector('.rewards-modal').style.display='none';">Close</button>
    `;
    rewardsModal.style.display = 'block';
    animateRewardCounter('rewardMana', rewards.mana);
    animateRewardCounter('rewardGems', rewards.gems);
    animateRewardCounter('rewardCoins', rewards.coins);
}

function animateRewardCounter(id, finalValue) {
    let elem = document.getElementById(id);
    let current = 0;
    let increment = finalValue / 30;
    let counter = setInterval(() => {
        current += increment;
        if (current >= finalValue) {
            elem.textContent = `${id.split('reward')[1]}: ${finalValue}`;
            clearInterval(counter);
        } else {
            elem.textContent = `${id.split('reward')[1]}: ${Math.floor(current)}`;
        }
    }, 30);
}

export { saveRewards, showRewardsModal };
